<template>
  <div class="roam">
    <el-carousel trigger="click" height="410px" :interval="100000">
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <img :src="item.url" />
        <h3 class="small">{{ item.name }}</h3>

        <p>{{ item.font }}</p>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          name: "开发商简介",
          url: require("../assets/1.png"),
          font:
            "河北中天控股有限公司（简称：中天集团）始于1999年，历经32年开疆拓土成为一家多元化集团公司，业务涵盖综合地产、金融投资、商贸物流、餐饮服务、科技新能源，医疗保障、生物科 技等，业务辐射京津冀、两广及海南。2021年中天集团总资产达百亿元，员工2300 余人，坚持“品质赢天下，中天慧万家”的企业发展理念，屹立定州，面向全国，走向世界。",
        },
        {
          name: "企业荣誉",
          url: require("../assets/2.png"),
          font:
            "致力于公益事业，投资惠民工程，完成公益捐赠10余项，捐款3000多万元，2020年集团为定州红十字会抗击“冠状肺炎”捐款物资近63万元，同时建立河北德普瑞医疗器械有限公司，历经15天建造日产量7万只口罩的生产线为抗击疫情助力。中天集团多次获得“河北省诚信企业”、“ 河北省诚信商家”、“河北省创建示范单位”、“河北省捐资助学先进单位”、“定州市慈善总 会会长单位”等荣誉称号。",
        },
        {
          name: "项目概况",
          url: require("../assets/3.png"),
          font:
            "项目总占地120余亩，总建筑面积约20万㎡，总户数1028户，绿化率40%，建筑形式分为高层、洋房、别墅、跃墅等全系产品，是菁贵人物的一致选择。澳大利亚柏涛大师操刀设计，建筑风格为新亚洲风，“中魂西技”根植项目，既延续中式传统古风古韵，又采用西式的设计手法及技术， 两者兼容并蓄。",
        },
        {
          name: "项目理念",
          url: require("../assets/4.png"),
          font:
            "秉承“以爱为魂 以家为本”的理念，从每个家庭成员所需求的生活环境出发，探讨每个居住空间内业主会如何 开展生活。满足现代居住者关注家庭与健康，回归自然、回归家庭、回归 “熟人型社区”的理想居住状态。以领先的产品理念，健康的生活方式， 与定州这座不断向上的千年古城产生共鸣，叙笔美好。",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}

.roam {
  height: 278px;
  overflow-y: scroll;
}
.shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
  z-index: 1000;
}
h3 {
  line-height: 30px;
  font-size: 16px;
}
p {
  text-align: justify;
  font-size: 15px;
}
</style>
